// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"a44bec5b","383":"68902722"}[chunkId] + ".chunk.css";
};